import { Tooltip } from "@mui/material";
import { GridActionsCellItem } from "@mui/x-data-grid";

import { useState } from "react";
import ExtendModal from "../modals/ExtendModal";
import AddIcon from "@mui/icons-material/Add";
import { Ownership } from "../../../../apis/__generated__/graphql";

export interface ExtendButtonProps {
  refetch: () => void;
  row?: Ownership;
  disabled: boolean;
  onSelectedRow: () => void;
  onUnselectedRow: () => void;
}

export default function ExtendButton({
  refetch,
  row,
  disabled,
  onSelectedRow,
  onUnselectedRow,
}: ExtendButtonProps) {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
    onSelectedRow();
  };

  const handleClose = () => {
    setOpen(false);
    onUnselectedRow();
  };

  return (
    <>
      <GridActionsCellItem
        label="Extend"
        icon={
          <Tooltip title="Extend">
            <AddIcon />
          </Tooltip>
        }
        onClick={handleOpen}
        disabled={disabled}
      />
      {row && <ExtendModal row={row} open={open} onClose={handleClose} />}
    </>
  );
}
